<template>
  <div class="sub">
    <div v-for="(item,index) in data" :key="'g' + index">
      <span :style="item.children ? 'font-weight:900':'font-weight:normal'">
        {{item.name}}
      </span>
      <subitem :data="item.children" v-if="item.children && item.children.length > 0" style="margin-left:0.2rem" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'subitem',
    props: {
      data: Array
    },
  };
</script>

<style scoped>
  .sub div {
    line-height: 0.27rem;
    margin-top: 0.1rem;
  }
</style>